export const defaultContext = "primary"

export default {
    defaultContext
}